import { toggleScoring } from './scoring';

// Aplica um modelo da galeria sobre o formulário em branco.
//
// Mora aqui, e não dentro do FormEditor, porque a onda 2 fez o modelo carregar
// bem mais que campos e tema: pontuação, mensagem de conclusão e o texto da
// primeira mensagem da IA. Com o mapeamento em uma função pura dá para testar
// que um modelo de segmento chega no editor com a pontuação LIGADA e com faixas
// — que é justamente o que ninguém configurava à mão.
//
// Regra geral: o que o modelo não declara, o formulário em branco decide. Nunca
// sobrescrever um padrão com `undefined`.
export const templateToForm = (template, blank, baseTheme) => {
  const next = {
    ...blank,
    name: template.name,
    fields: template.fields.map(item => ({ ...item })),
    theme: { ...baseTheme, ...(template.theme || {}) },
  };

  // `scoring: { enabled: true }` sem faixas é o caso comum nos modelos: as
  // faixas padrão vêm do mesmo lugar que o toggle da tela usa, então modelo e
  // configuração manual nunca divergem.
  if (template.scoring) {
    next.scoring = toggleScoring(
      { ...template.scoring },
      !!template.scoring.enabled
    );
  }

  if (template.success_message) {
    next.success_mode = 'message';
    next.success_message = template.success_message;
  }

  // A nutrição por IA fica DESLIGADA: ela depende de uma caixa de WhatsApp que
  // só a conta sabe escolher. O modelo entrega o texto pronto, e ligar vira um
  // clique em vez de uma página em branco.
  if (template.ai_nurture) {
    next.ai_nurture = {
      ...(blank.ai_nurture || {}),
      ...template.ai_nurture,
      enabled: false,
    };
  }

  return next;
};
